import React, { useState } from "react";
import Drawer from 'react-modern-drawer';
import LabelServices from "./LabelServices"; 
import Modal from "react-responsive-modal";
import Pagination from "components/Common/newPagination";

export function LabelListing (param:any) {

    let [showTab , setShowTab] = useState(0);
    const [totalRow, inittotalRow] = useState(0);
    const toggleDrawer = () => {setIsOpen(!isOpen)}
    const [isOpen, setIsOpen] = React.useState(false);
    const [saveAlert , setsaveAlert] = useState(false); 
    const [saveAlertT , setsaveAlertT] = useState(false);   
    const [deleteAlert , setdeleteAlert] = useState(false);
      
    let [freeTextLabel, initfreeTextLabel] = useState<any[]>([]);
    let [freeTextLabelPag, initfreeTextLabelPag] = useState<any[]>([]);
    let [freeTextLabelEdit, initfreeTextLabelEdit] = useState<any>([]);
    let [freeTextLabelSearch, initfreeTextLabelSearch] = useState<any>([]);
    const [freeTextInsertPanel , setfreeTextInsertPanel] = useState(false);  

    var payload = {
        "formArea": "ShortLabelCode"
    }

    const apiCall = () => {

        if(freeTextLabelSearch.length > 0){
            var data = {
            "usecode" : freeTextLabelSearch,
            "useFreeText" : freeTextLabelSearch,
            "showSequence" : freeTextLabelSearch
            }        
            payload = {...payload , ...data}
        }

        LabelServices.freeText(payload).then( (data)=>{
            inittotalRow(data.length)
            initfreeTextLabelPag(data)
            freeTextLabel = data.slice((1 -1 ) * 10,(10*1 ))   
            initfreeTextLabel(freeTextLabel);            
        })
    }    

    const handleNameOnChangeImprint = (n: any) => {
        freeTextLabel = freeTextLabelPag.slice((n.pageNumber -1 ) * n.pageSize,(n.pageSize*n.pageNumber ))   
        initfreeTextLabel(freeTextLabel); 
    }

    const editFreeText = (n:any) => {
        initfreeTextLabelEdit(n)
        setfreeTextInsertPanel(true)
    }

    const upSert = () => {
        LabelServices.freeTextSave(freeTextLabelEdit).then( (data)=>{
            apiCall();    
            setsaveAlert(true)      
        })        
        setTimeout(function(){
            setsaveAlert(false)
        }, 3000);
    }

    const deleteFreeText = () => {        
        LabelServices.freeTextDelete(freeTextLabelEdit.freeId).then( (data)=>{
            apiCall();  
            setdeleteAlert(true)        
        }) 
        setTimeout(function(){
            setdeleteAlert(false)
        }, 3000);
    }
    const fieldHandle = (e:any) => {
        var name = e.target.name;
        initfreeTextLabelEdit((values: any) => ({...values , [name] :e.target.value  , "formArea" :"ShortLabelCode"} ));
        console.log(freeTextLabelEdit)
    }

    const closeLabelListing = () => {
        param.closeLabelListing();
    }

    return (
        <>             

            <Modal open={param.open} onClose={() => closeLabelListing()}>
                <div >
                    <div className="box-header-main ps pll ">
                        <h2 >Select the label / Create a new one</h2>
                    </div>

                    <div className="box-content box pLarge">
                        <div className="form-horizontal" > 
                            
                            <div className="form-format ws-4">
                                <label className="control-label" >Label</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter label" value={freeTextLabelSearch} onChange={(e)=>{initfreeTextLabelSearch(e.target.value)}}/>
                                </div>
                            </div>
                                
                            <button className="icon-btn edit btn-small mtxl" onClick={apiCall}><i className="fa fa-search"></i> Search</button>                        
                        </div>

                       { (totalRow === 0) && <div className="alert alert-info mt  ">No records to display</div>}

                        {(totalRow > 0) && <div className="box-header well">
                           <h2> <i className="fa fa-table"></i> <span >{totalRow} record(s) found</span>  </h2>
                        </div>}

                       {saveAlert && <div className="alert alert-success"> Label has been saved successfully</div>}
                       {deleteAlert && <div className="alert alert-success"> Label has been deleted successfully</div>}

                       <table className="newTable" >
                            <thead>
                                <tr>
                                    <th >ShortLabelCode Code</th>
                                    <th >ShortLabelCode Desc</th>
                                    <th >Sequence</th>
                                    <th style = {{minWidth: 200 }}>Operation</th>
                                </tr>
                            </thead>

                            <tbody>

                            {freeTextLabel.map( (data) => { 
                                return (
                                    <tr >
                                            <td>{data.useCode}</td>
                                            <td>{data.useFreeText}</td>
                                            <td>{data.showSequence}</td>
                                            <td>
                                                <a className="icon-btn info btn-s" onClick={() =>{param.onchangeImprint(data);setIsOpen(!isOpen) }}><i className="fa fa-check"></i>Select</a>
                                                <a className="icon-btn edit btn-s" onClick={() =>editFreeText(data)}><i className="icon-edit1"></i></a>
                                                <a className="icon-btn delete btn-s"  onClick={() =>{editFreeText(data);deleteFreeText()}}><i className="icon-trashcan"></i></a>
                                            </td>                                       
                                    </tr>
                                )})                               
                            }

                            {freeTextInsertPanel &&  <>                                
                                
                                <tr>
                                    <td><input type="text" className="ws-12" name="useCode" onChange={fieldHandle} value={freeTextLabelEdit.useCode}/></td>
                                    <td><input type="text" className="ws-12" name="useFreeText" onChange={fieldHandle} value={freeTextLabelEdit.useFreeText}/></td>
                                    <td><input type="text" className="ws-12" name="showSequence" onChange={fieldHandle} value={freeTextLabelEdit.showSequence}/></td>
                                    <td>
                                       <a className="icon-btn edit btn-s" onClick={()=>{upSert();}}><i className="fa fa-save"></i>Save</a>
                                       <a className="icon-btn delete btn-s" onClick={()=>setfreeTextInsertPanel(false)}><i className="fa fa-close"></i>Cancel</a>
                                    </td>
                                </tr>
                                    
                            </ > }

                            </tbody>

                        </table>

                        <div className="ws-12 ptl " >
                            {     
                                (() => {
                                    if(totalRow && totalRow > 10){
                                        return <Pagination onPageChange={handleNameOnChangeImprint} totalRow={totalRow} />  
                                    }                                                
                                })()
                            }  
                        </div>

                        <div className='box-footer'>                        
                            <button className="icon-btn delete pull-right mb mt mrl" onClick={() => {setIsOpen(!isOpen)} }>Close</button>  
                            <button className="icon-btn edit pull-right mb mt mrl" onClick={()=>{initfreeTextLabelEdit([]) ;setfreeTextInsertPanel(true)}}><i className="icon-plus1"></i>Label</button>                     
                                                
                       </div>
                    </div>

                    
                </div>

            </Modal>

        </>
    )
}